
// const timeMap = new Map();

export function addPerformanceListener() {
  const performance = wx.getPerformance?.();
  const observer = performance?.createObserver((entryList) => {
    if (entryList?.getEntries()?.length > 0) {
      let appStartTime = 0;
      let firstContentfulPaintTime = 0;
      let firstContentfulPaintPath = 0;
      entryList.getEntries().forEach((item) => {
        // if (item.name === 'route') {
        //   console.log(`jaydenwu debug route ${item.path}`, item.duration);
        //   if (!timeMap.has(item.path)) {
        //     timeMap.set(item.path, { time: 0, count: 0 });
        //   } else {
        //     const timeInfo = timeMap.get(item.path);
        //     timeInfo.time = timeInfo.time + item.duration;
        //     timeInfo.count = timeInfo.count + 1;
        //   }
        // }
        if (item.entryType === 'navigation' && item.navigationType !== 'navigateBack') {
          if (item.name === 'appLaunch' && item.startTime > 0) {
            appStartTime =  item.startTime;
          }
          reportDuration(`navigation-${item.name}-${item.path}`, item.duration);
        } else if (item.entryType === 'loadPackage') {
          reportDuration(`loadPackage-${item.name}-${item.packageName}`, item.duration);
        } else if (item.entryType === 'render' && item.name === 'firstContentfulPaint') {
          firstContentfulPaintTime = item.startTime;
          firstContentfulPaintPath = item.path;
        }
        if (appStartTime > 0 && firstContentfulPaintTime > 0) {
          reportDuration(`render-appLaunch-firstContentfulPaint-${firstContentfulPaintPath}`, firstContentfulPaintTime - appStartTime);
          firstContentfulPaintTime = 0;
        }
      });
    }
  });
  observer?.observe({ entryTypes: ['render', 'navigation', 'loadPackage'] });
}

function reportDuration(key, duration) {
  if (duration > 0) {
    const { mAegis: aegis } = window;
    console.log('Performance report:', key, duration);
    if (!aegis) return;
    aegis.reportTime(key, Math.round(duration));
  }
}
